import { useTranslation } from 'react-i18next';
import { clinicScenarios } from '@/mocks/corporateClinicData';

const scenarioImages = [
  '/images/generated/clinic-scenario-1.jpg',
  '/images/generated/clinic-scenario-2.jpg',
  '/images/generated/clinic-scenario-3.jpg',
];

function renderParagraphs(value: string, className: string) {
  return value.split(/\n{2,}/).filter((part) => part !== '').map((para, i) => (
    <p key={i} className={className}>
      {para}
    </p>
  ));
}

export default function ScenarioTraining() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {renderParagraphs(t('corporateClinic.scenario.label'), 'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label')}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateClinic.scenario.title')}
          </h2>
          {renderParagraphs(t('corporateClinic.scenario.titleEn'), 'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4')}
          <div className="gold-line mx-auto mb-5"></div>
          {renderParagraphs(t('corporateClinic.scenario.lead'), 'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto')}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {clinicScenarios.map((scenario, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 overflow-hidden group cursor-default"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={scenarioImages[idx]}
                  alt={t(`corporateClinic.scenario.${idx}.title`)}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-0 left-0 w-10 h-10 bg-primary-900/80 flex items-center justify-center">
                  <span className="text-accent-400 text-[15px] font-bold tracking-[0.08em]">{scenario.number}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                  {t(`corporateClinic.scenario.${idx}.title`)}
                </h3>
                {renderParagraphs(t(`corporateClinic.scenario.${idx}.desc`), 'text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed')}
              </div>
            </div>
          ))}
        </div>

        {renderParagraphs(t('corporateClinic.scenario.note'), 'text-center mt-8 text-[14px] text-foreground-400 tracking-[0.04em]')}
      </div>
    </section>
  );
}
